
import React from "react";
import PasswordResetForm from "./reset-password/PasswordResetForm";
import PasswordResetSuccess from "./reset-password/PasswordResetSuccess";
import { usePasswordReset } from "./reset-password/usePasswordReset";

const ResetPasswordForm = () => {
  const { loading, errorMessage, passwordUpdated, resetPassword } = usePasswordReset();

  if (passwordUpdated) {
    return <PasswordResetSuccess />;
  }

  return (
    <PasswordResetForm
      onSubmit={resetPassword}
      loading={loading}
      errorMessage={errorMessage}
    />
  );
};

export default ResetPasswordForm;
